import type { TOC } from '@ember/component/template-only'
import { eq } from 'ember-truth-helpers'

interface Args {
  themeKey?: string
}

interface Signature {
  Args: Args
  Element: HTMLSelectElement
  Blocks: {
    default: []
  }
}

// {{! A themed select component }}
// {{! Uses native select hence does not support styling of options }}

export const BaseSelect: TOC<Signature> = <template>
  <select
    class="select-caret-icon cursor-pointer appearance-none rounded-md border border-dusty-black-100 bg-white bg-[length:0.7rem] bg-[right_-1.5rem_center] bg-no-repeat bg-origin-content py-1 pl-1 pr-7 transition-colors transition-opacity duration-200 disabled:cursor-not-allowed disabled:bg-dusty-black-100
      {{unless
        @themeKey
        'text-neutral-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-325'
      }}
      {{if
        (eq @themeKey 'blue')
        'text-dusty-black-300 focus:border-oceany-blue-400 focus:outline-oceany-blue-300/[0.75]'
      }}
      {{if (eq @themeKey 'green') 'text-dusty-black-300 focus:border-ms-green-400 focus:outline-ms-green-300/[0.75]'}}
      {{if (eq @themeKey 'dark-blue') 'text-dusty-black-300 focus:border-wl-blue-250 focus:outline-wl-blue-300/[0.75]'}}
      "
    ...attributes
  >
    {{yield}}
  </select>
</template>

export default BaseSelect
